<template>
  <v-card class="secondary" height="100%">
    <v-form ref="form">
      <v-card-title class="font-weight-medium secondary--text primary">
        Set Academic Concession
        <v-spacer></v-spacer>
        <v-btn small icon @click="$emit('closeDialog')">
          <v-icon small color="secondary">mdi-close</v-icon>
        </v-btn>
      </v-card-title>

      <v-card-text class="pt-5">
        <v-row>
          <v-col cols="4">
            <v-text-field
              v-model="form.usn_id"
              label="USN"
              outlined
              dense
              hide-details="auto"
              readonly
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="form.amount"
              label="Amount"
              outlined
              dense
              hide-details="auto"
              readonly
            />
          </v-col>
          <v-col cols="4">
            <v-text-field
              v-model="form.concession_amount"
              label="Concession Amount*"
              outlined
              dense
              hide-details="auto"
              type="number"
              :rules="[rules.required, rules.float]"
            />
          </v-col>
          <v-col cols="12">
            <v-text-field
              v-model="form.remarks"
              label="Remarks*"
              outlined
              dense
              hide-details="auto"
              :rules="[rules.required]"
            />
          </v-col>
        </v-row>
      </v-card-text>
      <v-card-actions class="pt-0 mb-3 mx-2">
        <v-spacer></v-spacer>
        <v-btn class="primary" @click="save" :loading="loading">Save</v-btn>
      </v-card-actions>
    </v-form>
    <v-dialog v-model="confirmDialog" width="500" persistent>
      <confirmationDialogForm
        v-if="confirmDialog"
        :confirmationText="'This concession cannot be reverted once saved. Are you sure you want to proceed?'"
        @closeDialog="confirmDialog = false"
        @saveDialog="confirmSave()"
      />
    </v-dialog>
  </v-card>
</template>

<script>
import { rules } from "@/helpers/rules";
import confirmationDialogForm from "../confirmationDialog.vue";

export default {
  props: {
    data: {
      type: Object,
      default: () => ({}),
    },
    loading: {
      type: Boolean,
      default: () => false,
    },
  },
  components: { confirmationDialogForm },
  data() {
    return {
      rules,
      form: {},
      confirmDialog: false,
    };
  },
  computed: {},
  created() {
    this.form = { ...this.data };
  },
  methods: {
    save() {
      if (!this.$refs.form.validate()) return;
      this.confirmDialog = true;
    },
    confirmSave() {
      this.confirmDialog = false;
      this.$emit("create", this.form);
    },
    cancelSave() {
      this.confirmDialog = false;
    },
  },
};
</script>
